import * as React from "react";
import Svg, { Path, Rect } from "react-native-svg";

export function UserVotedIcon(props: any) {
  return (
    <Svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <Rect width="18" height="18" rx="9" fill="#849617" />
      <Path
        d="M13 6L7.5 11.5L5 9"
        stroke="#F9F8F0"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Svg>
  );
}
